import { StyleSheet, TouchableOpacity } from 'react-native';
import styled from 'styled-components';
import styledNative from 'styled-components';

import Colors from '../../config/Colors';
import Layout from '../../config/Layout';
import { Replay } from '@mui/icons-material';

export default StyleSheet.create({
    contentRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    text: {
        textAlign: 'left'
    },
    icon: {
        marginLeft: Layout.gutterSmall
    }
});

const WarningConnection = styledNative(TouchableOpacity)`
    position: absolute;
    height: ${Layout.heightDM};
    width: 380px;
    margin: 0 calc(50% - 190px);
    display: flex;
    align-items: 'center';
    justify-content: 'center';
    flex-direction: 'row';
    padding: 0 15px;
    flex: 1;
    background-color: ${Colors.danger};
    color: white;
    text-align: center;
    font-size: 16px;
    line-height: ${Layout.lineHeightDM};
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 8px;
`;

const StyledIcon = styled(Replay)`
    display: flex;
    margin-top: 0 !important;
    margin-left: 0 !important;
`;

export { WarningConnection, StyledIcon };
